'use es6';

import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { H4 } from 'UIComponents/elements/headings';
import ToolAccessApprovalSentResult from './ToolAccessApprovalSentResult';
import ToolAccessGuardError from './components/guard/ToolAccessGuardError';
import ToolAccessGuardRequestPending from './components/guard/ToolAccessGuardRequestPending';
import withErrorBoundary from './hoc/withErrorBoundary';
import withToolAccess from './hoc/withToolAccess';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ToolAccessGuard({
  toolAccess
}) {
  useEffect(() => toolAccess.fetchRequest(), []); // eslint-disable-line react-hooks/exhaustive-deps
  if (toolAccess.loading) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        position: 'relative'
      },
      children: /*#__PURE__*/_jsx(UILoadingOverlay, {
        contextual: true
      })
    });
  }
  if (toolAccess.error) {
    return /*#__PURE__*/_jsx(ToolAccessGuardError, {});
  }
  // REQUEST CREATED IN CURRENT SESSION
  if (toolAccess && toolAccess.requestCreated) {
    return /*#__PURE__*/_jsx(ToolAccessApprovalSentResult, {
      approver: toolAccess.request.approver
    });
  }
  // PENDING
  if (toolAccess && toolAccess.request) {
    return /*#__PURE__*/_jsx(ToolAccessGuardRequestPending, {
      toolAccess: toolAccess
    });
  }
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    "data-test-id": "tool-access-guard-error-message",
    illustration: "keys",
    title: /*#__PURE__*/_jsx(H4, {
      children: !toolAccess.toolName ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.defaultTitle"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "toolAccess.guardTitle",
        options: {
          value: toolAccess.toolName
        }
      })
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "toolAccess.guardBody"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "tool-access-request-access",
        use: "primary",
        onClick: toolAccess.openModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "toolAccess.requestPermissionUpdate"
        })
      })]
    })
  });
}
ToolAccessGuard.propTypes = {
  toolAccess: PropTypes.object
};
export default compose(withErrorBoundary, withToolAccess)(ToolAccessGuard);